import { EMOBILITY_BRANDS, EmobilityVendors } from '@store/enums';
import { IotPairingModel } from 'swagger-http/models';

// GridX and Enode are both electric car vendors
export const isElectricCarVendor = (vendor?: string): boolean => {
    return (
        !!vendor &&
        (vendor === EmobilityVendors.ENODE || vendor === EmobilityVendors.GRIDX)
    );
};

// GridX and Enode are both electric car brands
export const isElectricCarBrand = (name?: string): boolean => {
    return (
        !!name &&
        (name === EMOBILITY_BRANDS[EmobilityVendors.ENODE] ||
            name === EMOBILITY_BRANDS[EmobilityVendors.GRIDX])
    );
};

export const removeUnsupportedElectricCarVendors = (
    vendors: IotPairingModel[],
    hasGridXAutopilotScope: boolean,
): IotPairingModel[] => {
    if (!hasGridXAutopilotScope) {
        // remove gridX from the list if the user may not link via gridX
        return vendors.filter(
            (vendor: IotPairingModel) => vendor.name !== EmobilityVendors.GRIDX,
        );
    }

    // remove enode from the list if the user may link via gridX
    return vendors.filter(
        (vendor: IotPairingModel) => vendor.name !== EmobilityVendors.ENODE,
    );
};
